// extracted by mini-css-extract-plugin
export var centerText = "_do-8";
export var container = "_do-0";
export var doughnutContainer = "_do-7";
export var legend = "_do-a";
export var legendItemColorDisplay = "_do-b";
export var legendItemLabel = "_do-d";
export var legendItemValue = "_do-c";
export var lg = "_do-5";
export var maxWidth = "_do-9";
export var md = "_do-4";
export var responsive = "_do-6";
export var sm = "_do-3";
export var xs = "_do-2";
export var xxs = "_do-1";